import { type FC } from "react";
import type { AdapterFormats } from "@mui/x-date-pickers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import type { Dayjs } from "dayjs";
import dayjs, { ISO_DATE_FORMAT } from "../../../dayjs";

interface Props {
  label: string;
  value: string;
  helperText?: string;
  onChange: (value: string) => void;
}

const dateFormats: Partial<AdapterFormats> = { keyboardDate: "DD.MM.YYYY" };

const FilterDateField: FC<Props> = ({ label, value, helperText, onChange }) => {
  const handleChange = (date: Dayjs | null) => {
    if (date === null) {
      onChange("");
    } else if (date.isValid()) {
      onChange(date.format(ISO_DATE_FORMAT));
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pl" dateFormats={dateFormats}>
      <DatePicker
        label={label}
        value={value ? dayjs(value, ISO_DATE_FORMAT) : null}
        onChange={handleChange}
        slotProps={{
          textField: { size: "small", helperText },
          field: { clearable: true },
        }}
      />
    </LocalizationProvider>
  );
};

export default FilterDateField;
